"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExamSuiteHelperVarName = exports.getFnNameForSettingExamSuiteHelperInTaskRunnerScript = exports.getAuxTaskNameForSavingFinalRuntimeOutput = exports.getAuxRpcTaskStructureAlias = exports.getWorkflowAsAuxTaskFnName = exports.getTaskFunctionName = void 0;
/**
 * Builds name of a task-runner function. Used by task-runner to call/execute the function, and by backend-server to build the script itself.
 *
 * @param structureUid
 */
function getTaskFunctionName(structureUid) {
    return `task_${structureUid}`;
}
exports.getTaskFunctionName = getTaskFunctionName;
/**
 * Builds name of auxiliary function used by task-runner to add controlData to a task-runner response.
 * (controlData is info for kahba-runner to use, like a workflow branch that is determined using a reducer action type, while
 *  the rest of the action payload is unavailable to kahba-runner.)
 *
 * @param structureUid
 */
function getWorkflowAsAuxTaskFnName(structureUid) {
    return `auxTask_${structureUid}`;
}
exports.getWorkflowAsAuxTaskFnName = getWorkflowAsAuxTaskFnName;
function getAuxRpcTaskStructureAlias(modelType) {
    return `auxRpc_${modelType}`;
}
exports.getAuxRpcTaskStructureAlias = getAuxRpcTaskStructureAlias;
// export function getAuxRpcTaskFunctionName(modelType: string) {
//   return getTaskFunctionName(getAuxRpcTaskStructureAlias(modelType));
// }
function getAuxTaskNameForSavingFinalRuntimeOutput() {
    return '_$w_saveKahbaRuntimeOutput';
}
exports.getAuxTaskNameForSavingFinalRuntimeOutput = getAuxTaskNameForSavingFinalRuntimeOutput;
function getFnNameForSettingExamSuiteHelperInTaskRunnerScript() {
    return '_$w_setExamSuiteHelper';
}
exports.getFnNameForSettingExamSuiteHelperInTaskRunnerScript = getFnNameForSettingExamSuiteHelperInTaskRunnerScript;
/**
 * Reference to ExamSuiteHelper
 *
 * See projects/task-runner/src/sandboxed-processor/handy-task-helper/exam-suite-task-helper.ts
 */
function getExamSuiteHelperVarName() {
    return '_$w_examSuiteHelper';
}
exports.getExamSuiteHelperVarName = getExamSuiteHelperVarName;
//# sourceMappingURL=task-function-name.js.map